import * as React from "react";
const SvgFiRrSymbols = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-symbols_svg__a)">
      <path
        fill="#062147"
        d="M0 1a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1m4 9a1 1 0 1 0 2 0V6h3a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2h3zM23.033.686A2.8 2.8 0 0 0 20.8.029L17.576.49A3.014 3.014 0 0 0 15 3.46v3.541a2 2 0 1 0 1.999 2.052L17 9.001V3.459c0-.494.369-.92.859-.989l3.224-.461a.8.8 0 0 1 .64.188.79.79 0 0 1 .277.606v3.196a2 2 0 1 0 1.999 2.052L24 7.999V2.804c0-.813-.353-1.585-.967-2.118M22 20a2 2 0 1 0-.001 3.999A2 2 0 0 0 22 20m-6-3a2 2 0 1 0 .001-3.999A2 2 0 0 0 16 17m7.665-3.747a1 1 0 0 0-1.412.083l-8 9a.999.999 0 1 0 1.495 1.328l8-9a1 1 0 0 0-.083-1.411m-11.807 5.262a18 18 0 0 1-1.584 2.2l1.466 1.612A.998.998 0 0 1 11.001 24a1 1 0 0 1-.74-.327l-1.372-1.508C7.767 23.177 6.418 24 5.001 24c-2.375 0-3.971-1.418-3.971-3.529 0-1.372 1.497-3.08 2.543-4.105-.315-.402-.572-.879-.572-1.365 0-1.103.897-2 2-2s2 .897 2 2c0 .513-.286 1.015-.624 1.431l2.53 2.782a16 16 0 0 0 1.237-1.728 1 1 0 1 1 1.714 1.029m-4.32 2.165-2.595-2.853c-1.066 1.062-1.914 2.208-1.914 2.644C3.029 21.851 4.407 22 5 22c.816 0 1.715-.569 2.538-1.32"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-symbols_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSymbols;
